'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import ThemeReviewability from '../../records/ThemeReviewability';

const WriteReviewButton = ({
  className,
  disabled,
  onClick,
  reviewability,
  size
}) => {
  const isReviewable = reviewability.isReviewable();
  const reason = reviewability.getUnreviewableReason();
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-assets-ui.themes.details.reviews.unreviewable.${reason}`
      }),
      disabled: isReviewable,
      placement: "left",
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: "tertiary",
        size: size,
        disabled: disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.details.reviews.write.button"
        })
      })
    })
  });
};

WriteReviewButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  reviewability: PropTypes.instanceOf(ThemeReviewability).isRequired,
  size: PropTypes.string
};
WriteReviewButton.defaultProps = {
  disabled: false,
  size: 'sm'
};
export default WriteReviewButton;